<template>
	<div class="com">
		<div class="srcolldiv">
			<adsSteps :activeValue="activeValue" :stepList="stepList" @toSkip="toSkip"></adsSteps>
			<tip-steps v-bind="activeObj"></tip-steps>
			<div class="main">
				<component
            ref="component"
					:is="activeObj.name"
					:bindValue="bindValue"
					@toNext="toNext"
					@toPrev="toPrev"
					@toSkip="toSkip"
				>
				</component>
			</div>
		</div>
	</div>
</template>

<script>
import adsSteps from '@/components/adsOnlineAuto/ads-steps';
import tipSteps from '@/components/adsOnlineAuto/tip-steps';
import stepList from '@/components/adsOnlineAuto/mainPages/index.js';
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			stepList,
			activeValue: 1,
			bindValue: null,
		};
	},

	components: { adsSteps, tipSteps },

	computed: {
		...mapGetters(['finishValue']),
		activeObj() {
			let Obj = this.stepList.filter(e => {
				return e.number == this.activeValue;
			});
			return Obj[0];
		},
		queryParam() {
			return this.$route.query;
		},
	},
	methods: {
		toNext(val) {
			if (val) {
				this.bindValue = val;
			}
			this.activeValue++;
		},
		toPrev(val) {
			if (val) {
				this.bindValue = val;
			}
			this.activeValue--;
		},
		toSkip(val) {
			this.activeValue = val;
		},
	},
	mounted()
	{
		this.$store.dispatch('getstepstatus',this.queryParam.id).then(()=>{
			this.activeValue=this.finishValue;
		});
	}
};
</script>

<style lang="scss" scoped>
.main {
	/* min-height: 300p	x; */
	// background: #ffffff;
	box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
	margin: 10px 0px;
}
.com {
	width: 100%;
	height: calc(100vh - 175px);

	// padding: 0px 20px 10px 20px;
	display: flex;
	flex-direction: column;
	.srcolldiv {
		flex: 1;
		height: calc(100vh - 175px);
		display: flex;
		flex-direction: column;
		overflow-x: hidden;
		overflow-y: scroll;
	}
	/*滚动条样式*/
	.srcolldiv::-webkit-scrollbar {
		position: relative;
		width: 6px;
	}
	.srcolldiv::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
		background: rgba(163, 155, 155, 0.2);
	}
	// .srcolldiv::-webkit-scrollbar-track {
	// 	box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
	// 	border-radius: 0;
	// 	background: rgba(193, 185, 185, 0.1);
	// }
}
</style>
